<div class="container-fluid py-1 h-full-header">
  <div class="row h-100">
    <div class="col-4 h-100 overflow-auto scroll-lg border-right p-0">
      <h5 class="text-center dark-gray-bg f-yellow p-2 sticky d-flex align-items-center" style="top: 0 !important">
        <div class="flex-grow-1">عنوان‌های شغلی</div>
        <!-- <button class="btn btn-white fs-sm mx-2" (click)="unusedModal.open()">استفاده نشده ها</button> -->
        <div>
          <button class="btn btn-white btn-sm mx-1" (click)="modifyModal.open()">ویرایش داده‌ها</button>
          <button class="btn btn-white btn-sm mx-1" (click)="importModal.open()">ایمپورت</button>

        </div>
      </h5>
      <div class="p-2">
        <form class="d-flex flex-wrap justify-content-between align-items-center mb-2 pb-2 border-bottom">
          <div class="m-1 flex-fill">
            <input type="search" class="p-1" placeholder="جستجو" name="search" [(ngModel)]="search">
          </div>
          <label class="m-1 fs-sm">
            <input type="checkbox" name="searchAll" [(ngModel)]="searchAll"> جستجو در همه فیلدها
          </label>
          <div class="m-1">
            <select class="p-1" name="completed" [(ngModel)]="completed">
              <option [ngValue]="undefined">وضعیت تکمیل</option>
              <option [ngValue]="true">تکمیل شده</option>
              <option [ngValue]="false">تکمیل نشده</option>
            </select>
          </div>
          <div class="m-1">
            <select class="p-1" name="useForAlert" [(ngModel)]="useForAlert">
              <option [ngValue]="undefined">وضعیت آلرت</option>
              <option [ngValue]="true">استفاده برای آلرت</option>
              <option [ngValue]="false">عدم استفاده برای آلرت</option>
            </select>
          </div>
          <div class="m-1">
            <select class="p-1" name="useForTagging" [(ngModel)]="useForTagging">
              <option [ngValue]="undefined">وضعیت تگینگ</option>
              <option [ngValue]="true">تگینگ</option>
              <option [ngValue]="false">نا تگینگ</option>
            </select>
          </div>
          <div class="m-1">
            <select class="p-1" name="isRemote" [(ngModel)]="isRemote">
              <option [ngValue]="undefined">وضعیت دورکاری</option>
              <option [ngValue]="true">دورکاری</option>
              <option [ngValue]="false">نا دورکاری</option>
            </select>
          </div>
        </form>
        <form class="mb-1">
          <div class="d-flex mb-1">
            <div>
              <input type="text" class="p-1" placeholder="عنوان شغلی" #title />
            </div>
            <button class="btn btn-white btn-sm fs-sm mx-2" (click)="add(title);">افزودن</button>
          </div>

        </form>
        <div class="relative" style="min-height: 200px;">
          <ngx-spinner name="titles" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
          <table class="table table-striped table-hover table-condensed">
            <tbody>
              <tr *ngFor="let item of filteredJobTitles" class="pointer">
                <td class="p-0">
                  <div class="d-flex justify-content-between border-2 border-dark-gray p-1 "
                    [class.border]="item == selected" [title]="item.UpdateDate|pdate">
                    <div (click)="selected=item;selectedLink=undefined;selectedField=undefined;"
                      class="flex-grow-1 fs-normal">
                      <div [class.font-wight-bold]="!item.IsDisabled" [class.f-gray]="item.IsDisabled">{{item.Title}}
                        <span class="badge green-bg f-white mr-2 " *ngIf="item.IsCompleted">تکمیل شده</span>
                        <span class="badge orange-bg f-white mr-2 " *ngIf="item.UseForAlert">آلرت</span>
                        <span class="badge yellow-bg mr-2 " *ngIf="item.UseForTagging">تگینگ</span>
                        <span class="badge violet-bg f-white mr-2 "
                          *ngIf="item.RemoteJobType">{{item.RemoteJobType}}</span>
                      </div>

                    </div>
                    <div (confirm)="copy(item)" class="px-1 pointer">کپی</div>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-4 h-100 overflow-auto scroll-lg border-right px-0">
      <ng-container *ngIf="selected">
        <h4 class="d-flex align-items-center justify-content-between light-gray-bg sticky px-2"
          style="top: 0 !important">
          <div>{{selected.Title}}</div>
          <button class="btn btn-link f-red"
            message="در صورتی که مهارت یا رشته تحصیلی فقط در این عنوان شغلی تعریف شده باشد، همراه آن حذف خواهد شد. آیا مطمئن هستید؟"
            (confirm)="delete(selected)">حذف</button>
        </h4>

        <div class="d-flex flex-wrap mb-1 p-1 justify-content-between align-items-center">
          <div>
            <input type="text" class="p-1" placeholder="عنوان شغلی جایگزین" name="title" [(ngModel)]="selected.Title">
          </div>
          <label class="d-flex align-items-center pointer">
            <input type="checkbox" name="disabled" [(ngModel)]="selected.IsDisabled">
            غیرفعال
          </label>
          <label class="d-flex align-items-center pointer">
            <input type="checkbox" name="completed" [(ngModel)]="selected.IsCompleted">
            تکمیل شده
          </label>
          <label class="d-flex align-items-center pointer">
            <input type="checkbox" name="alert" [(ngModel)]="selected.UseForAlert">
            آلرت
          </label>
          <label class="d-flex align-items-center pointer">
            <input type="checkbox" name="tag" [(ngModel)]="selected.UseForTagging">
            تگینگ
          </label>
          <button class="btn btn-white btn-sm fs-sm mx-2" (click)="save(selected)">ذخیره</button>
        </div>

        <div class="">
          <div class="card my-1">
            <div class="card-header pointer p-1 text-center" id="RemoteHeader">
              <h6 class="mb-0" data-toggle="collapse" data-target="#Remote" aria-expanded="false"
                aria-controls="Remote">محتوای دورکاری</h6>
            </div>
            <div id="Remote" class="collapse relative" aria-labelledby="RemoteHeader">
              <ngx-spinner name="Remote" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
              <div class="card-body p-2 d-flex flex-column">
                <label class="d-flex align-items-center pointer">
                  <div>
                    اصطلاح دورکاری
                  </div>
                  <input type="text" name="remote" dir="ltr" [(ngModel)]="selected.RemoteJobType">
                </label>
                <div>
                  <div>
                    تصویر
                  </div>
                  <input type="url" class="p-1" placeholder="لینک تصویر" name="image" [(ngModel)]="selected.Image">
                  <img *ngIf="selected.Image" [src]="selected.Image" class="m-1 rounded-xl shadow-kp contain"
                    style="width: 80px;height: 80px;" />
                </div>
                <div>
                  <div>
                    توضیح کوتاه
                  </div>
                  <textarea placeholder="توضیح کوتاه" name="brief" [(ngModel)]="selected.Brief" rows="5"></textarea>
                </div>
                <div>
                  متن صفحه
                  <angular-editor placeholder="متن صفحه" name="description" class="pre-wrap"
                    [(ngModel)]="selected.Description">
                  </angular-editor>
                </div>
                <div class="p-2 white-bg sticky-bottom">
                  <button class="btn btn-white btn-sm fs-sm mx-2" (click)="save(selected)">ذخیره</button>
                </div>

              </div>
            </div>

          </div>
          <div class="card my-1">
            <div class="card-header pointer p-1 text-center" id="StatisticsHeader">
              <h6 class="mb-0" data-toggle="collapse" data-target="#Statistics" aria-expanded="false"
                aria-controls="Statistics">آمار</h6>
            </div>
            <div id="Statistics" class="collapse relative" aria-labelledby="StatisticsHeader">
              <ngx-spinner name="statistics" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
              <div class="card-body p-2">
                <div>
                  <button class="btn btn-secondary btn-sm" (click)="setStatistics(selected)">محاسبه آمار</button>
                  <button class="btn btn-secondary btn-sm mx-2"
                    (click)="getSuggestions(selected);suggestionsModal.open()">پیشنهادها</button>
                  <button class="btn btn-link fs-sm mx-2"
                    (click)="singleExportImport.open();selectedJson.value=''">اکسپورت - ایمپورت</button>
                </div>
                <div class="fs-sm d-flex justify-content-between">
                  <div>
                    <h6>کارجو</h6>
                    <div>تعداد تگ شده: {{selected.SeekerStats?.TaggedCount | number}}</div>
                    <div>تعداد جاری: {{selected.SeekerStats?.Count | number}}</div>
                    <div>بیشترین امتیاز: {{selected.SeekerStats?.MaxScore | number}}</div>
                    <div>میانه امتیاز: {{selected.SeekerStats?.MedianScore | number}}</div>
                    <div>میانگین امتیاز: {{selected.SeekerStats?.AvgScore | number}}</div>
                    <div>انحراف معیار امتیاز: {{selected.SeekerStats?.ScoreStdDeviation | number}}</div>
                    <div *ngIf="selected.SeekerStats?.CalculationTime">تاریخ محاسبه:
                      {{selected.Statistics?.CalculationTime | pdate}}</div>
                    <div>
                      <button class="btn btn-secondary btn-sm"
                        (click)="seekersModal.open();seekerOrder.value='desc';seekerLocation=undefined;seekerOrder.mode='search';searchSeekers(selected)">جستجو</button>
                      <button class="btn btn-secondary btn-sm" (click)="tagSeekers(selected)">اعمال تگ ها</button>
                      <button class="btn btn-secondary btn-sm"
                        (click)="seekersModal.open();seekerOrder.value='desc';seekerLocation=undefined;seekerOrder.mode='tagged';taggedSeekers(selected);">تگ
                        شده‌ها</button>
                      <button class="btn btn-secondary btn-sm" (confirm)="removeSeekerTags(selected)">حذف تگ ها</button>
                    </div>
                  </div>
                  <div>
                    <h6>آگهی</h6>
                    <div>تعداد تگ شده: {{selected.JobStats?.TaggedCount | number}}</div>
                    <div>تعداد جاری: {{selected.JobStats?.Count | number}}</div>
                    <div>بیشترین امتیاز: {{selected.JobStats?.MaxScore | number}}</div>
                    <div>میانه امتیاز: {{selected.JobStats?.MedianScore | number}}</div>
                    <div>میانگین امتیاز: {{selected.JobStats?.AvgScore | number}}</div>
                    <div>انحراف معیار امتیاز: {{selected.JobStats?.ScoreStdDeviation | number}}</div>
                    <div *ngIf="selected.JobStats?.CalculationTime">تاریخ محاسبه:
                      {{selected.Statistics?.CalculationTime | pdate}}</div>
                    <div>
                      <button class="btn btn-secondary btn-sm"
                        (click)="jobsModal.open();jobOrder.value='desc';jobLocation=undefined;jobOrder.mode='search';searchJobs(selected)">جستجو</button>
                      <button class="btn btn-secondary btn-sm" (click)="tagJobs(selected)">اعمال تگ ها</button>
                      <button class="btn btn-secondary btn-sm"
                        (click)="jobsModal.open();jobOrder.value='desc';jobLocation=undefined;jobOrder.mode='tagged';taggedJobs(selected)">تگ
                        شده‌ها</button>
                      <button class="btn btn-secondary btn-sm" (confirm)="removeJobTags(selected)">حذف تگ ها</button>
                    </div>
                  </div>
                </div>


              </div>
            </div>

          </div>

          <div class="card my-1">
            <div class="card-header pointer p-1 text-center" id="variationsHeader">
              <h6 class="mb-0" data-toggle="collapse" data-target="#variations" aria-expanded="false"
                aria-controls="variations">
                جایگزین ها
              </h6>
            </div>

            <div id="variations" class="collapse show" aria-labelledby="variationsHeader">
              <div class="card-body p-2">
                <div class="d-flex mb-1">
                  <div>
                    <input type="text" class="p-1" placeholder="عنوان شغلی" #variation>
                  </div>
                  <button class="btn btn-white btn-sm fs-sm mx-2"
                    (click)="selected.Variations.push(variation.value);save(selected, variation);">افزودن</button>
                </div>
                <div class="">
                  <div class="py-1 px-2 rounded-xl dark-gray-bg f-yellow fs-sm d-inline m-1 no-wrap"
                    *ngFor="let item of selected.Variations;let index=index">
                    {{item}}
                    <i class="fa fa-times fs-xl pointer mr-2"
                      (click)="selected.Variations.splice(index,1);save(selected);"></i>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="card my-1">
            <div class="card-header pointer p-1 text-center" id="informalVariationsHeader">
              <h6 class="mb-0" data-toggle="collapse" data-target="#informalVariations" aria-expanded="false"
                aria-controls="informalVariations">جایگزین های غیر رسمی ({{selected.InformalVariations?.length}})</h6>
            </div>

            <div id="informalVariations" class="collapse" aria-labelledby="informalVariationsHeader">
              <div class="card-body p-2">
                <div class="d-flex mb-1">
                  <div>
                    <input type="text" class="p-1" placeholder="عنوان شغلی" #informalVariation>
                  </div>
                  <button class="btn btn-white btn-sm fs-sm mx-2"
                    (click)="selected.InformalVariations.push(informalVariation.value);save(selected, informalVariation);">افزودن</button>
                  <button class="btn btn-white btn-sm fs-sm mx-2"
                    (click)="getVariationSuggestions(selected);variationSuggestionsModal.open()">پیشنهادها</button>
                </div>
                <div class="">
                  <div class="py-1 px-2 rounded-xl dark-gray-bg f-yellow fs-sm d-inline m-1 no-wrap"
                    *ngFor="let item of selected.InformalVariations;let index=index">
                    {{item}}
                    <i class="fa fa-times fs-xl pointer mr-2"
                      (click)="selected.InformalVariations.splice(index,1);save(selected);"></i>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="card my-1" *ngFor="let field of Object.keys(fields)">
            <div class="card-header pointer p-1 text-center" [id]="'Header'+field">
              <h6 class="mb-0" data-toggle="collapse" [attr.data-target]="'#'+field" aria-expanded="false"
                [attr.aria-controls]="field">{{fields[field]}}</h6>
            </div>

            <div [id]="field" class="collapse show" [attr.aria-labelledby]="field+'Header'">
              <div class="card-body p-2">
                <div class="form-group d-flex mb-1">
                  <ng-select class="w-100" [attr.name]="field+'-title'" [addTag]="true" [items]="data[field]"
                    [virtualScroll]="true" [placeholder]="'انتخاب '+fields[field]+' اصلی'"
                    (change)="$event && addLink(selected,field,$event)" [closeOnSelect]="false">
                    <ng-template ng-option-tmp let-item="item">
                      <ng-container *ngTemplateOutlet="selectorLinkTemplate;context:{key:item,field:field}">
                      </ng-container>
                    </ng-template>
                  </ng-select>
                </div>
                <table class="table table-striped table-hover table-condensed">
                  <tbody>
                    <tr *ngFor="let link of selected[field]?.sort(compareLink);let index=index" class="">
                      <td class="p-0">
                        <div [class.border]="link.Id==selectedLink?.Id"
                          class="border-2 border-dark-gray px-1 d-flex justify-content-between align-items-center">
                          <div (click)="selectLink(field, link)" class="pointer flex-grow-1 ml-2">
                            {{link.Title}}
                          </div>
                          <div class="d-flex  align-items-center">
                            <label class="d-flex align-items-center ml-3 pointer">
                              <input type="checkbox" name="required" [(ngModel)]="link.IsRequired"
                                (change)="save(selected)" />
                              ضروری
                            </label>
                            <input type="number" inputmode="numeric" name="score" [(ngModel)]="link.Score"
                              (change)="save(selected)" style="width: 60px" class="p-0 text-center ml-1" />
                            <i class="fa fa-times f-red fs-xl pointer" (click)="removeLink(selected,field,link.Id)"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card my-1">
            <div class="card-header pointer p-1 text-center" id="HeaderExcluded">
              <h6 class="mb-0" data-toggle="collapse" data-target="#Excluded" aria-expanded="false"
                aria-controls="Excluded">کلمات کلیدی استثنا شده</h6>
            </div>
            <div id="Excluded" class="collapse show" aria-labelledby="HeaderExcluded">
              <div class="card-body p-2">
                <div class="d-flex mb-1">
                  <div>
                    <input type="text" class="p-1" placeholder="کلمه کلیدی" #excluded>
                  </div>
                  <button class="btn btn-white btn-sm fs-sm mx-2"
                    (click)="selected.Excluded.push(excluded.value);save(selected, excluded);">افزودن</button>
                </div>
                <div class="d-flex flex-wrap">
                  <div class="badge dark-gray-bg f-yellow fs-sm fs-normal m-1 no-wrap"
                    *ngFor="let item of selected.Excluded;let index=index">
                    {{item}}
                    <i class="fa fa-times fs-lg pointer mr-2"
                      (click)="selected.Excluded.splice(index,1);save(selected);"></i>
                  </div>
                </div>

              </div>
            </div>

          </div>
          <div class="card my-1">
            <div class="card-header pointer p-1 text-center" id="HeaderNegative">
              <h6 class="mb-0" data-toggle="collapse" data-target="#Negative" aria-expanded="false"
                aria-controls="Negative">کلمات کلیدی امتیاز منفی</h6>
            </div>
            <div id="Negative" class="collapse show" aria-labelledby="HeaderNegative">
              <div class="card-body p-2">
                <div class="d-flex mb-1">
                  <div>
                    <input type="text" class="p-1" placeholder="کلمه کلیدی" #negative>
                  </div>
                  <button class="btn btn-white btn-sm fs-sm mx-2"
                    (click)="selected.Negative.push(negative.value);save(selected, negative);">افزودن</button>
                </div>
                <div class="d-flex flex-wrap">
                  <div class="badge dark-gray-bg f-yellow fs-sm fs-normal m-1 no-wrap"
                    *ngFor="let item of selected.Negative;let index=index">
                    {{item}}
                    <i class="fa fa-times fs-lg pointer mr-2"
                      (click)="selected.Negative.splice(index,1);save(selected);"></i>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="col-4 h-100 overflow-auto scroll-lg border-right px-0">
      <div *ngIf="selectedLink">
        <h4 class="d-flex align-items-center justify-content-between light-gray-bg sticky px-2"
          style="top: 0 !important">
          {{selectedLink.Title}}
          <button class="btn btn-link f-red" (confirm)="deleteLink(selectedField, selectedLink)">حذف از تمام عناوین
            شغلی</button>
        </h4>
        <div class="d-flex mb-1 p-1 border-bottom">
          <div>
            <input type="text" class="p-1" [(ngModel)]="selectedLink.Title">
          </div>
          <button class="btn btn-white btn-sm fs-sm mx-2" (click)="saveLink(selectedField, selectedLink)">ذخیره</button>
        </div>

        <div class="p-2">
          <div class="d-flex mb-1">
            <ng-select class="w-100" name="link-variation" [addTag]="true" [items]="data[selectedField]"
              [virtualScroll]="true" [placeholder]="'انتخاب جایگزین - ' + fields[selectedField]"
              (change)="$event && selectedLink.Variations.push($event)"
              (blur)="setVariation(selectedField,selectedLink)" [closeOnSelect]="false">
              <ng-template ng-option-tmp let-item="item">
                <ng-container *ngTemplateOutlet="selectorLinkTemplate;context:{key:item,field:selectedField}">
                </ng-container>
              </ng-template>
            </ng-select>

          </div>

          <table class="table table-striped table-hover table-condensed">
            <tbody>
              <tr *ngFor="let link of selectedLink.Variations;let index=index" class="">
                <td class="p-0">

                  <div class="border-2 border-dark-gray px-1 d-flex justify-content-between">
                    <div>{{link}}</div>
                    <div class="d-flex">
                      <i class="fa fa-times f-red fs-xl pointer"
                        (click)="selectedLink.Variations.splice(index,1);setVariation(selectedField,selectedLink);"></i>
                    </div>

                  </div>

                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="m-2 p-2 rounded-xl light-gray-bg">
          <h6 class="text-center">({{linkUsage(selectedField, selectedLink.Id).length}} عنوان شغلی)</h6>

          <div>
            <span class="px-2 rounded-xl white-bg m-1" *ngFor="let title of linkUsage(selectedField, selectedLink.Id)">
              {{title.Title}}
            </span>
          </div>
        </div>



      </div>

    </div>

  </div>
</div>


<ng-template #selectorLinkTemplate let-key="key" let-field="field">
  <div class="d-flex justify-content-between" [class.text-success]="!!usage(field,key,selected)">
    <div class="">[{{key}}]</div>
    <div class="">
      <div class="badge">{{usage(field, key)}}</div>
    </div>
  </div>
</ng-template>

<ng-template #selectorItemTemplate let-key="key" let-field="field">
  <div [class.text-success]="selected[field].includes(key)">{{key}}</div>
</ng-template>

<ngx-smart-modal #seekersModal identifier="seekersModal" customClass="full-width">
  <div class="relative pt-2 h-100">
    <ngx-spinner name="seekers" [fullScreen]="false" type="timer"></ngx-spinner>
    <div class="d-flex flex-column h-100">
      <div class="d-flex justify-content-between px-3">
        <div>تعداد: {{seekersCount | number}}</div>
        <div>
          <select #seekerOrder>
            <option value="desc">نزولی</option>
            <option value="asc">صعودی</option>
            <option value="random">رندوم</option>
          </select>
        </div>
        <div class="w-25">
          <app-location name="location" [(ngModel)]="seekerLocation"></app-location>
        </div>
        <div>
          <select #seekerLimit>
            <option value="0">0</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500" selected>500</option>
          </select>
          <button class="btn btn-secondary btn-sm"
            (click)="seekerOrder.mode=='tagged' ? taggedSeekers(selected, seekerOrder.value, seekerLimit.value): searchSeekers(selected, seekerOrder.value, seekerLimit.value)">
            دریافت
          </button>
        </div>
      </div>
      <div class="table-responsive flex-fill  scroll-lg" style="min-height: 400px;">
        <table class="table table-striped table-bordered table-hover table-sm w-100 td-capped">
          <thead>
            <tr>
              <th class="sticky white-bg fw-bold">نام</th>
              <th class="sticky white-bg fw-bold">درباره</th>
              <th class="sticky white-bg fw-bold">سابقه</th>
              <th class="sticky white-bg fw-bold">مهارت</th>
              <th class="sticky white-bg fw-bold">تحصیلات</th>
              <th class="sticky white-bg fw-bold">سابسکرایب</th>
              <th class="sticky white-bg fw-bold">امتیاز</th>
              <th class="sticky white-bg fw-bold">ارتباط</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of seekers" class="fs-sm">
              <td><a [routerLink]="['/resume',user.Seeker?.Code]" target="_blank">{{user.Name || user.Seeker?.Code}}
                  ({{user.Seeker?.Completeness}})</a>
              </td>
              <td>
                <div [innerHTML]="user.Seeker.About"></div>
              </td>
              <td>
                <div>"{{user.Seeker.Experiences|join:'", "':'Position'}}"</div>
              </td>
              <td>
                <div>"{{user.Seeker.Skills|join:'", "':'Title'}}"</div>
              </td>
              <td>
                <div>"{{user.Seeker.Educations|join:'", "':'Field'}}"</div>
              </td>
              <td>
                <div>"{{user.Seeker.JobAlertSettings?.Searches|join:'", "':'Keyword'}}"</div>
              </td>
              <td>
                <div>{{user._Score}}</div>
              </td>
              <td>
                <div>{{user._NormalScore}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


  </div>
</ngx-smart-modal>
<ngx-smart-modal #jobsModal identifier="jobsModal" customClass="full-width">
  <div class="relative pt-2 h-100">
    <ngx-spinner name="jobs" [fullScreen]="false" type="timer"></ngx-spinner>

    <div class="d-flex flex-column h-100">
      <div class="d-flex justify-content-between px-3">
        <div>تعداد: {{jobsCount | number}}</div>
        <div>
          <select #jobOrder>
            <option value="desc">نزولی</option>
            <option value="asc">صعودی</option>
            <option value="random">رندوم</option>
          </select>
        </div>
        <div class="w-25">
          <app-location name="location" [(ngModel)]="jobLocation"></app-location>
        </div>
        <div>
          <select #jobLimit>
            <option>500</option>
            <option>100</option>
            <option>10</option>
          </select>
        </div>
        <label>
          <input type="checkbox" #debug />
          دیباگ
        </label>
        <div>
          <button class="btn btn-secondary btn-sm"
            (click)="jobOrder.mode=='tagged' ? taggedJobs(selected, jobOrder.value, jobLimit.value): searchJobs(selected, jobOrder.value, jobLimit.value, debug.checked)">
            دریافت
          </button>
        </div>
      </div>

      <div class="table-responsive flex-fill  scroll-lg" style="min-height: 400px;">
        <table class="table table-striped table-bordered table-hover table-sm w-100 td-capped">
          <thead>
            <tr>
              <th class="sticky white-bg fw-bold">عنوان</th>
              <th class="sticky white-bg fw-bold">متن</th>
              <th class="sticky white-bg fw-bold">مهارت</th>
              <th class="sticky white-bg fw-bold">امتیاز</th>
              <th class="sticky white-bg fw-bold">ارتباط</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let job of jobs" class="fs-sm">
              <td><a [href]="'/admin/ads;job=' + job.Id" target="_blank">{{job.Title}}</a></td>
              <td>
                <div class="col-6" [innerHTML]="job.Description"></div>
              </td>
              <td>
                <div>{{job.RequiredSkills|join:' | '}}</div>
              </td>
              <td>{{job._Score}}</td>
              <td>{{job._NormalScore}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ngx-smart-modal>

<!-- <ngx-smart-modal #unusedModal identifier="unusedModal" customClass="full-width">
  <div class="container relative p-2 h-full-header scroll-lg" *ngIf="data">
    <div class="d-flex mb-2">
      <div>
        <label>انتخاب بخش
          <select [(ngModel)]="modifyField">
            <option value="Skills">مهارت</option>
            <option value="Educations">رشته تحصیلی</option>
            <option value="Subscriptions">سابسکرایب</option>
            <option value="Queries">جستجو</option>
          </select>
        </label>
      </div>
      <div>
        <label>فقط استفاده نشده ها
          <input type="checkbox" [(ngModel)]="modifyField" name="just-unused" />
        </label>
      </div>
      <div>
        <label>جستجو
          <input type="text" [(ngModel)]="searchUnused" name="search-unused" />
        </label>
      </div>
      <div>
        <button class="btn btn-transparent-border" (click)="openModify()" *ngIf="modifyItems.length>1">ویرایش
          گروهی</button>
      </div>
    </div>
    <cdk-virtual-scroll-viewport itemSize="18" style="height:500px">
      <div class="rounded-xl border border-dark-gray p-1 m-1 pointer d-flex justify-content-between"
        *cdkVirtualFor="let key of unusedItems">
        <div class="d-flex">
          <input *ngIf="modifyField || !usage(modifyField, key)" type="checkbox" [ngModel]="modifyItems.includes(key)"
            (ngModelChange)="toggleSelectModify(key)" />
          <div>[{{key}}]</div>
        </div>
        <i class="fa fa-edit fs-xl pointer mr-2" (click)="openModify(key);"></i>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</ngx-smart-modal> -->

<!-- <ngx-smart-modal #modifyModal identifier="modifyModal" [ngSwitch]="modifyField" customClass="full-width">
  <div class="container relative p-2 h-full-header scroll-lg" *ngIf="data">
    <ngx-spinner name="modify" [fullScreen]="false" type="timer"></ngx-spinner>
    <div class="mb-2">
      <div class="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
        <h2>ویرایش [<ng-container *ngFor="let modify of modifyItems"> | "{{modify}}"</ng-container>]</h2>
        <button class="btn btn-link f-red" (confirm)="deleteModify()">حذف</button>
      </div>

      <div class="border-bottom pb-3 mb-3">
        <ng-select class="w-100" name="modify-skill-title" [multiple]="true" [addTag]="true" [items]="data[modifyField]"
          [(ngModel)]="modifyTo" [virtualScroll]="true" placeholder="انتخاب جایگزین">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="selectorLinkTemplate;context:{key:item,field:modifyField}">
            </ng-container>
          </ng-template>
        </ng-select>
        <div class="my-2 text-left">
          <button class="btn btn-transparent-border" (confirm)="sendModify()">تبدیل به جایگزین ها</button>
        </div>
      </div>

      <ng-container *ngIf="modifyItems.length==1">
        <div class="border-bottom pb-3 mb-3">
          <ng-select class="w-100" name="modify-job-title" [multiple]="true" [addTag]="true" [items]="jobTitles"
            [(ngModel)]="modifyJobTitles" [virtualScroll]="true" placeholder="انتخاب جاب تایتل" bindLabel="Title">
          </ng-select>
          <div class="my-2 text-left">
            <button class="btn btn-transparent-border" (confirm)="addToJobTitle()">اتصال به جاب تایتلها</button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ngx-smart-modal> -->
<ngx-smart-modal #importModal identifier="importModal">
  <div class="container">
    <div>
      <textarea rows="20" style="width: 400px;" [(ngModel)]="importList"></textarea>
    </div>
    <div class="p-2 text-left">
      <div class="btn btn-primary" (click)="import()">ایمپورت</div>
    </div>
  </div>
</ngx-smart-modal>
<ngx-smart-modal #modifyModal identifier="modifyModal" customClass="full-width">
  <div class="container relative p-2 h-full-header scroll-lg" *ngIf="data">
    <div class="mb-2">
      <label>انتخاب بخش
        <select [(ngModel)]="modifyField" (change)="resetModifies()">
          <option value="Experiences">سابقه شغلی</option>
          <option value="Skills">مهارت</option>
          <option value="Educations">رشته تحصیلی</option>
          <option value="Subscriptions">سابسکرایب</option>
          <option value="Queries">جستجو</option>
        </select>
      </label>
      <ng-select class="w-100" name="modify-skill-search" [multiple]="true" [addTag]="true" [items]="data[modifyField]"
        [(ngModel)]="modifyItems" [virtualScroll]="true" placeholder="انتخاب" [closeOnSelect]="false"
        (change)="checkJobTitles()">
        <ng-template ng-option-tmp let-item="item">
          <ng-container *ngTemplateOutlet="selectorLinkTemplate;context:{key:item,field:modifyField}">
          </ng-container>
        </ng-template>
      </ng-select>
    </div>

    <section [ngSwitch]="modifyField">
      <div class="container relative p-2 h-full-header scroll-lg" *ngIf="data">
        <ngx-spinner name="modify" [fullScreen]="false" type="timer"></ngx-spinner>
        <div class="mb-2">
          <!-- <div class="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
            <h2>ویرایش [<ng-container *ngFor="let modify of modifyItems"> | "{{modify}}"</ng-container>]</h2>
            <button class="btn btn-link f-red" (confirm)="deleteModify()">حذف</button>
          </div> -->

          <div class="border-bottom pb-3 mb-3">
            <div class="d-flex">
              <label class="fs-sm no-wrap">
                <input type="checkbox" [(ngModel)]="onlyVerified">
                فقط تایید شده ها
              </label>
              <ng-select class="w-100" name="modify-skill-title" [multiple]="true" [addTag]="true"
                [items]="data[onlyVerified ? modifyField+ '_used' : modifyField]" [(ngModel)]="modifyTo"
                [virtualScroll]="true" placeholder="انتخاب جایگزین" [closeOnSelect]="false">
                <ng-template ng-option-tmp let-item="item">
                  <ng-container *ngTemplateOutlet="selectorLinkTemplate;context:{key:item,field:modifyField}">
                  </ng-container>
                </ng-template>
              </ng-select>
            </div>
            <div class="my-2 text-left">
              <button class="btn btn-transparent-border" (confirm)="sendModify()">تبدیل به جایگزین ها</button>
            </div>
          </div>

          <ng-container *ngIf="modifyItems.length==1">
            <div class="border-bottom pb-3 mb-3">
              <ng-select class="w-100" name="modify-job-title" [multiple]="true" [addTag]="true" [items]="jobTitles"
                [(ngModel)]="modifyJobTitles" [virtualScroll]="true" placeholder="انتخاب جاب تایتل" bindLabel="Title">
              </ng-select>
              <div class="my-2 text-left">
                <button class="btn btn-transparent-border" (confirm)="addToJobTitle()">اتصال به جاب تایتلها</button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </section>
  </div>
</ngx-smart-modal>
<ngx-smart-modal #singleExportImport identifier="singleExportImport" customClass="full-width">
  <section class="container p-2">
    <button class="btn btn-secondary" (click)="selectedJson.value = JSON.stringify(selected)">اکسپورت</button>
    <textarea #selectedJson rows="20" class="w-100 text-left fs-sm m-3" dir="ltr"></textarea>
    <button class="btn btn-secondary"
      (confirm)="importSingle(selected, selectedJson.value);singleExportImport.close()">ایمپورت</button>
  </section>
</ngx-smart-modal>
<ngx-smart-modal #suggestionsModal identifier="suggestionsModal" customClass="full-width">
  <div class="p-1 mb-1 border-bottom d-flex justify-content-between">
    <div>
      <button class="btn btn-secondary btn-sm mx-1" (click)="getSuggestions(selected)">
        دریافت مجدد
      </button>
      <button class="btn btn-secondary btn-sm mx-1" (click)="removeExistingSuggestions()">
        استفاده شده ها رو نشون نده
      </button>
    </div>
    <div>
      <button class="btn btn-primary btn-sm mx-1" (confirm)="addSuggestions();suggestionsModal.close()">
        افزودن پیشنهادها
      </button>
    </div>
  </div>
  <div class="container d-flex justify-content-between h-100" *ngIf="suggestions">
    <div class="overflow-auto container-capped-xs border-left h-100">
      <h6>عنوان جایگزین</h6>
      <div *ngFor="let item of suggestions.position">
        <ng-container *ngTemplateOutlet="suggestionItemTemplate;context:{item:item, field:'Experiences'}">
        </ng-container>
      </div>
    </div>
    <div class="overflow-auto container-capped-xs border-left h-100">
      <h6>مهارت</h6>
      <div *ngFor="let item of suggestions.skill">
        <ng-container *ngTemplateOutlet="suggestionItemTemplate;context:{item:item, field:'Skills'}">
        </ng-container>
      </div>
    </div>
    <div class="overflow-auto container-capped-xs border-left h-100">
      <h6>رشته</h6>
      <div *ngFor="let item of suggestions.field">
        <ng-container *ngTemplateOutlet="suggestionItemTemplate;context:{item:item, field:'Educations'}">
        </ng-container>
      </div>
    </div>
    <div class="overflow-auto container-capped-xs border-left h-100">
      <h6>سابسکرایب</h6>
      <div *ngFor="let item of suggestions.subscribe">
        <ng-container *ngTemplateOutlet="suggestionItemTemplate;context:{item:item, field:'Subscriptions'}">
        </ng-container>
      </div>
    </div>
  </div>
</ngx-smart-modal>
<ng-template #suggestionItemTemplate let-item="item" let-field="field">
  <div class="fs-sm py-1 border-bottom d-flex justify-content-between align-items-center" [class.yellow-bg]="item._add">
    <div class="d-flex align-items-center">
      <i class="fa fa-check f-green fs-lg" *ngIf="item.exists"></i>
      <input type="checkbox" *ngIf="!item.exists" (change)="item._add=$event.target.checked">
      <ng-container *ngIf="!item._modified">
        "{{item.Key}}" ({{item.DocCount}})
      </ng-container>
      <ng-container *ngIf="item._modified">
        <del>"{{item.Key}}" ({{item.DocCount}})</del>
        <span class="mط-1" *ngFor="let m of item._modified">{{m}}</span>
      </ng-container>
    </div>
    <div>
      <i class="fa fa-exchange-alt f-gray fs-lg pointer" (click)="item._edit=true"></i>
    </div>
  </div>
  <div class="py-1 border-bpttom border-2" *ngIf="item._edit">
    <h6>جایگزین‌ها</h6>
    <ng-select class="w-100" name="modify-skill-title" [multiple]="true" [addTag]="true" [items]="data[field]"
      [(ngModel)]="modifyTo" [virtualScroll]="true" placeholder="انتخاب جایگزین" [closeOnSelect]="false">
      <ng-template ng-option-tmp let-item="item">
        <ng-container *ngTemplateOutlet="selectorLinkTemplate;context:{key:item,field:field}">
        </ng-container>
      </ng-template>
    </ng-select>
    <div class="text-left py-1">
      <button class="btn btn-link ml-2" (click)="item._edit=false">انصراف</button>
      <button class="btn btn-primary btn-sm" (confirm)="modifySuggestion(field, item, modifyTo);">تبدیل
        به جایگزین ها</button>
    </div>
  </div>

</ng-template>

<ngx-smart-modal #variationSuggestionsModal identifier="variationSuggestionsModal" customClass="full-width">
  <div class="p-1 mb-1 border-bottom d-flex justify-content-between">
    <button class="btn btn-primary btn-sm mx-1" (confirm)="addVariationSuggestions();variationSuggestionsModal.close()">
      افزودن پیشنهادها
    </button>
  </div>
  <div class="container d-flex justify-content-between h-100">
    <div class="overflow-auto container-capped-xs border-left h-100">
      <h6>عنوان جایگزین</h6>
      <div *ngFor="let item of variationSuggestions">{{item}}</div>
    </div>
  </div>
</ngx-smart-modal>